import { combineReducers, configureStore, Middleware, Tuple } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import {
  createStateSyncMiddleware,
  initMessageListener,
} from "redux-state-sync";
import { loadStorage, saveStorage } from "../shared/utils/localStorage";
import { GeneralReducer } from "./reducers/general-reducer";

const persistentState = loadStorage();
const stateSyncMiddleware = createStateSyncMiddleware({
  broadcastChannelOption: { type: "localstorage" },
});
const rootReducer = combineReducers({
  GeneralData: GeneralReducer,
});

const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistentState,
  middleware: () => new Tuple(thunk, stateSyncMiddleware as Middleware),
});

initMessageListener(store);

store.subscribe(() => {
  saveStorage(store.getState());
});

export default store;
